import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../services/data.service';

@Pipe({
  name: 'formatDias'
})
export class FormatDiasPipe implements PipeTransform {

  public linguagem = "pt-BR";

  constructor(
    private data:DataService
  ){

    this.linguagem = this.data.getLinguagem();

  }

  transform(dias:any,args:any):any {
    
    let result = "Todos os dias da semana.";
    let _e     = "e";

    if(dias.length > 1){
      
      if(dias.length < 7){

        let d = "";

        for (let index = 0; index < dias.length;index++) {
          
          if(index > 0 && (index+1) < dias.length){
            d += ", ";
          }
          if(dias.length == (index+1)){
            d += ` ${_e} `;
          }

          if(this.linguagem == "pt-BR"){
            d += dias[index].descricao;
          }else{
            d += dias[index].descricao;
          }
          
          
        }


        result = d+".";

      }

    }else{

      result = dias[0].descricao+".";

    }

    return result;

  }

}
